import { EmpDataState } from '.';
import { EmployeeData } from '../../shared/models/EmpDetails';
import initialState from '../initialState';
import { EmpDetailsAction } from './actions';
import { EmpDetailsActionTypes } from './types';

export const empDetailReducer = (state = initialState.empData, action: EmpDetailsAction): EmpDataState => {
    switch (action.type) {
        case EmpDetailsActionTypes.GET_DATA_SUCCESS: {
            const response = action.payload.response as EmployeeData; 

            if (!response || !response.employeeDetail) {
                return state; // Return the current state if response is not valid
            }

            const {
                employeeDetail: {
                    employeeId,
                    employeeFirstName,
                    employeeLastName,
                    userPrincipalName,
                    stationName,
                    contractName,
                },
                schedules = [],
                absentDetails = []
            } = response;

            return {
                ...state,
                employeeDetail: {
                    employeeId,
                    employeeFirstName,
                    employeeLastName,
                    userPrincipalName,
                    stationName,
                    contractName,
                    allowNoScheduleCallout: response.employeeDetail.allowNoScheduleCallout,
                    isActiveQuestionJuryDuty: response.employeeDetail.isActiveQuestionJuryDuty,
                    isActiveQuestionBereavement: response.employeeDetail.isActiveQuestionBereavement,
                    isActiveQuestionApplyPTO: response.employeeDetail.isActiveQuestionApplyPTO || '',
                    commentLengthCheck: (response.employeeDetail as any).commentLengthCheck || 0,
                    absentPoints: (response.employeeDetail as any).absentPoints ?? null
                },
                schedules: schedules.map((schedule: any) => ({
                    employeeId: schedule.employeeId,
                    scheduleId: schedule.scheduleId,
                    stringSchedule_StartTime: schedule.stringSchedule_StartTime,
                    stringSchedule_EndTime: schedule.stringSchedule_EndTime,
                    stringSchedule_Hours: schedule.stringSchedule_Hours,
                    scheduleStartTimeUtc: schedule.scheduleStartTimeUtc,
                    scheduleEndTimeUtc: schedule.scheduleEndTimeUtc,
                    scheduleTimeRestrictionIsActive: schedule.scheduleTimeRestrictionIsActive,
                    submissionHrWindow: schedule.submissionHrWindow,
                    notificationRejectionMessage: schedule.notificationRejectionMessage,
                    scheduleCutoffHours: (schedule as any).scheduleCutoffHours ?? null,
                    scheduleCutoffHoursIsActive: (schedule as any).scheduleCutoffHoursIsActive ?? false
                })),
                absentDetails: absentDetails.map((absent: any) => ({
                    absentReasonId: absent.absentReasonId,
                    reasonDescription: absent.reasonDescription
                }))
            };
        }

        default:
            return state;
    }
};
